import UnstyledLink from './UnstyledLink';

export { Props, LinkLikeComponent } from './UnstyledLink';
export default UnstyledLink;
